// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"d6d3fb56","683":"a930e6a8","966":"e635ce5f"}[chunkId] + ".chunk.js";
};